"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
var _styles = require("@mui/material/styles");
const theme = exports.theme = (0, _styles.createTheme)({
  typography: {
    fontFamily: "var(--main-font-family)",
    lineHeight: "normal"
    // "fontSize": 14,
    // "fontWeightLight": 300,
    // "fontWeightRegular": 400,
    // "fontWeightMedium": 500
  }
});